import type { LicensedTerritory } from '@lottocom/lottery-mapping'

export const useIsPriceTransparencyEnabled = (state: LicensedTerritory) => {
  const { priceTransparencyEnabledStates } = useRuntimeConfig().public
  return priceTransparencyEnabledStates.split(',').includes(state)
}
